//index.js
import { configureStore } from "@reduxjs/toolkit";
import { collectionSlice } from "../slice/dataFetch"; // Ensure this is the correct import
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // default: local storage



const homeCollactionConfig = {
    key: "HomeCollaction", // Corrected spacing issues
    storage,
};

const electronicCollectionConfig = {
    key: "ElectronicCollection", // Corrected spacing issues
    storage,
};

const topCollectionConfig = {
    key: "TopCollection", // Corrected spacing issues
    storage,
};

const ourCollectionConfig = {
    key: "OurCollection", // Corrected spacing issues
    storage,
};


const homeCollectionpersistReducer = persistReducer(homeCollactionConfig, collectionSlice.reducer)
const electronicCollectionpersistReducer = persistReducer(electronicCollectionConfig, collectionSlice.reducer)
const topCollectionpersistReducer = persistReducer(topCollectionConfig, collectionSlice.reducer)
const ourCollectionpersistReducer = persistReducer(ourCollectionConfig, collectionSlice.reducer)


const store = configureStore({
    reducer: {
        homeImprovement: homeCollectionpersistReducer, // Use the reducer property of the slice
        electronicCollection: electronicCollectionpersistReducer, // Use the reducer property of the slice
        topCollection: topCollectionpersistReducer, // Use the reducer property of the slice
        ourCollection: ourCollectionpersistReducer,
    },
});
const persistor = persistStore(store);
export {store, persistor}